export default "__VITE_ASSET__2rcrTeBa__"